// api
export const APISentSuccessMsg = "Api sent succesfully";
export const APISentFailedMsg = "Api failed to send";
export const APIDeleteSuccessMsg = "Data is deleted successfully";
export const APIUpdateSuccessMsg = "Data is updated successfully";

// toast message
export const berhasilMembuatItemMsg = (item_name) =>
  `Berhasil membuat ${item_name} baru!`;
export const berhasilMengubahItemMsg = (item_name) =>
  `Berhasil mengubah ${item_name}!`;
export const berhasilMengeditItemMsg = (item_name) =>
  `Berhasil mengedit ${item_name}!`;
export const berhasilMenghapusItemMsg = (item_name) =>
  `Berhasil menghapus 1 ${item_name}!`;

export const getItemCreateSuccessMsg = (item_name) =>
  `${item_name} baru berhasil dibuat!`;

export const getItemSubmitSuccessMsg = (item_name) =>
  `Berhasil mengajukan ${item_name} baru!`;

export const getItemEditSuccessMsg = (item_name) =>
  `Data ${item_name} berhasil diubah!`;

export const getItemEditStatusSuccessMsg = (item_name) =>
  `Status ${item_name} Berhasil Diubah`;

export const getItemDeleteSuccessMsg = (item_name) =>
  `${item_name} berhasil dihapus!`;

// toast error message
export const getInputDateBeforeTodayError = () => "Masukkan Tanggal Yang Benar";

export const getFillAllFieldError = () => "Silahkan Isi Semua Field";
